import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import media from '../../../utils/mediaQueries';

import { ReviewForm } from './ReviewForm';
import { SuccessMessage } from './SuccessMessage';
import stores from '../../../stores';

const Container = styled.div`
  background: #fff;
  border-radius: 10px;
  margin: 24px 0;
  overflow: hidden;
  
  ${media.mobile`
    margin: 24px -8px;
  `}
`;

type ExamCenterReviewFormProps = {
  examCenterId: string;
  partnerReviewPayloadId: string;
  email: string;
  firstName: string;
  lastName: string;
  examCenterTitle: string;
  examCenterLogo: string;
  examCenterAddress: string;
  placeId: string;
  type: string;
  city: string;
  zipcode: string;
  phone: string;
};

const ExamCenterReviewForm = observer((props: ExamCenterReviewFormProps) => {
  const {
    isSent, rating, reviewId, selectedSchoolType,
  } = stores.examCenterReviewStore;
  const { isSent: isLeadsFormSent } = stores.leadsStore;

  useEffect(() => stores.examCenterReviewStore.resetExamCenterReviewStore(), []);

  return (
    <Container>
      {isSent
        ? (
          <SuccessMessage
            firstName={props.firstName}
            placeId={props.placeId}
            rating={rating}
            reviewId={reviewId}
            selectedSchoolType={selectedSchoolType}
            city={props.city}
            zipcode={props.zipcode}
            phone={props.phone}
            email={props.email}
            isLeadsFormSent={isLeadsFormSent}
          />
        )
        : <ReviewForm {...props} />}
    </Container>
  );
});

export { ExamCenterReviewForm };
